// Shared TanStack Query options for B.1.5 admin pages. Spread into
// useQuery / useInfiniteQuery so admin views opt in to focus-refetch
// without flipping the global default (which stays false to keep the
// legacy /fleet view's behaviour identical to pre-B.1.5).
//
//   useQuery({ ...adminQueryOptions, queryKey: qk.tenant(a, t),
//              queryFn: () => tenants.get(a, t).then(r => r.data) });
//
//   useInfiniteQuery({ ...adminQueryOptions, ... });

export const adminQueryOptions = {
  refetchOnWindowFocus: true,
  staleTime: 30_000,
} as const;
